const STORAGE_KEY = 'socmate_ticket_views';
const UNREAD_WINDOW_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

const getTicketViews = (): Record<string, number> => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch {
        return {};
    }
};

export const markTicketViewed = (ticketId: string): void => {
    try {
        const views = getTicketViews();
        views[ticketId] = Date.now();
        localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
    } catch {
        // localStorage may be unavailable in some environments
    }
};

/**
 * Returns true if the ticket should show an unread indicator.
 *
 * - Never viewed: unread only if updated within the last 7 days
 *   (avoids showing dots on every historical ticket for new users)
 * - Viewed before: unread if updated_at is newer than the last view timestamp
 */
export const isTicketUnread = (ticketId: string, updatedAt: string): boolean => {
    const views = getTicketViews();
    const lastViewed = views[ticketId];
    const updatedMs = new Date(updatedAt).getTime();

    if (!lastViewed) {
        return updatedMs > Date.now() - UNREAD_WINDOW_MS;
    }

    return updatedMs > lastViewed;
};
